import { REPORT_TEMPLATES_PREFERENCE_TYPE } from '../constants/reportConstants';

const normalizeReportPreferenceEntityKey = (entity: string) => {
    const trimmedEntity = entity.trim();
    return `${trimmedEntity.charAt(0).toUpperCase()}${trimmedEntity.slice(1)}`;
};

export const makeReportTemplatesPreferenceKey = (entity: string) => {
    const normalizedEntity = normalizeReportPreferenceEntityKey(entity);
    return `${REPORT_TEMPLATES_PREFERENCE_TYPE},entity=${normalizedEntity}`;
};
